import action from "../helpers/rest-client";

export class ErrorStatics extends Error {}

class Statics {
  public getAll({ page, limit }) {
    const offset = page * limit;

    return action
      .Get({
        url: `/course/categories?offset=${offset}&limit=${limit}`,
      })
      .then((response) => {
        return { response: response?.success?.result };
      })
      .catch((error) => {
        return { error };
      });
  }
}

const statics = new Statics();
export default statics;
